"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var convert_exports = {};
__export(convert_exports, {
  convertBBox: () => convertBBox,
  convertGeometry: () => convertGeometry
});
module.exports = __toCommonJS(convert_exports);
function convertBBox(bbox, convert) {
  if (bbox == null) {
    return void 0;
  } else {
    const [ax0, ay0, ax1, ay1] = bbox;
    const [bx0, by0] = convert([ax0, ay0]);
    const [bx1, by1] = convert([ax1, ay1]);
    return [bx0, by0, bx1, by1];
  }
}
function convertGeometry(geom, convert) {
  switch (geom.type) {
    case "Point":
      return {
        type: "Point",
        bbox: convertBBox(geom.bbox, convert),
        coordinates: convert(geom.coordinates)
      };
    case "MultiPoint":
      return {
        type: "MultiPoint",
        bbox: convertBBox(geom.bbox, convert),
        coordinates: geom.coordinates.map(convert)
      };
    case "LineString":
      return {
        type: "LineString",
        bbox: convertBBox(geom.bbox, convert),
        coordinates: geom.coordinates.map(convert)
      };
    case "MultiLineString":
      return {
        type: "MultiLineString",
        bbox: convertBBox(geom.bbox, convert),
        coordinates: geom.coordinates.map((line) => line.map(convert))
      };
    case "Polygon":
      return {
        type: "Polygon",
        bbox: convertBBox(geom.bbox, convert),
        coordinates: geom.coordinates.map((ring) => ring.map(convert))
      };
    case "MultiPolygon":
      return {
        type: "MultiPolygon",
        bbox: convertBBox(geom.bbox, convert),
        coordinates: geom.coordinates.map((poly) => poly.map((ring) => ring.map(convert)))
      };
    case "GeometryCollection":
      return {
        type: "GeometryCollection",
        bbox: convertBBox(geom.bbox, convert),
        geometries: geom.geometries.map((geom2) => convertGeometry(geom2, convert))
      };
  }
}
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  convertBBox,
  convertGeometry
});
//# sourceMappingURL=convert.js.map
